export const educationData = [
    {
      degree: "Graduation",
      title: "Bachelor of Technology",
      institution: "Arya College of Engineering & IT",
      batch: "2019-2023",
      cgpa: "8.56",
      location: "Jaipur, Rajasthan"
    },
    {
      degree: "Senior Secondary (Class XII)",
      institution: "My Own School",
      passingYear: "2018",
      percentage: "88.40%",
      location: "Jaipur, Rajasthan"
    },
    {
      degree: "Secondary (Class X)",
      institution: "My Own School",
      passingYear: "2016",
      percentage: "80.50%",
      location: "Jaipur, Rajasthan"
    }
  ];
  